import type { UseMutationOptions } from "react-query";
import { useMutation } from "react-query";

import type { CreateConnectionParams } from "@/react/api/connectionsApi";
import { connectionsApi } from "@/react/api/connectionsApi";

export const useCreateConnection = (
  options?: UseMutationOptions<any, Error, CreateConnectionParams>,
) => useMutation({ mutationFn: connectionsApi.createConnection, ...options });
